import createIcon from '../../createIcon';

/**
 * @component @name CandlestickChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA0SDdWNkg1VjE4SDdWMjBIOVYxOEgxMVY2SDlWNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSA4SDE3VjRIMTVWOEgxM1YxNUgxNVYyMEgxN1YxNUgxOVY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CandlestickChart = createIcon('CandlestickChart', [
  ['path', { d: 'M9 4H7V6H5V18H7V20H9V18H11V6H9V4Z', key: '2tykal' }],
  ['path', { d: 'M19 8H17V4H15V8H13V15H15V20H17V15H19V8Z', key: '16m2aa' }],
]);

export default CandlestickChart;
